module.exports = __webpack_public_path__ + "fonts/work-sans-v4-latin-ext-600.697830a4.ttf";